<template>
    <div id="edicaoItensLicitacao">
        <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(salvar)" class="">
                <b-row>
                    <b-col cols="6">
                        <h5 class="text-left">{{ editItem ? 'Atualizar' : 'Adicionar' }} Item</h5>
                    </b-col>
                    <b-col cols="6">
                        <b-button type="submit" size="sm" class="float-right mx-2">
                            <font-awesome-icon :icon="editItem ? 'edit' : 'plus'" />
                            {{ editItem ? 'Alterar' : 'Adicionar' }} Item
                        </b-button>
                        <b-button v-if="editItem" @click.prevent="limparForm" size="sm" variant="danger"
                            class="float-right">
                            <font-awesome-icon icon="ban" />
                            Cancelar alteração
                        </b-button>
                        <b-button v-if="!editItem" size="sm" class="float-right mx-2"
                            @click="exibirModalImportacao = true">
                            <font-awesome-icon icon="cloud-upload" class="" />
                            Importar Itens
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="Descrição do item" v-slot="defState" rules="max:4000">
                            <b-form-input v-model="novoItem.DeItemMatServ" :state="defState.state"></b-form-input>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="6" xl="3">
                        <default-form-validation-provider label="Quantidade" v-slot="defState">
                            <b-form-input v-model="novoItem.QtItemMatServ" v-bind="licitaQtdProps"
                                :state="defState.state" />
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="6" xl="2">
                        <default-form-validation-provider label="Un. de Medida" v-slot="defState" rules="max:100">
                            <b-form-input v-model="novoItem.DeUnidadeMedida" :state="defState.state"></b-form-input>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="3">
                        <default-form-validation-provider label="Valor de Ref. Unitário" v-slot="defState">
                            <money class="form-control" v-model="novoItem.VlUnitarioEstimado" :state="defState.state"
                                v-bind="vMoney4CasasOptions"></money>
                        </default-form-validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
        <b-row class="mt-2">
            <h5 class="ml-3 w-100 titulo-mobile d-flex justify-content-between align-items-center">
                Itens do Processo Licitatório
                <busca-tabela @busca="filtrarItens" />
            </h5>

            <b-table :fields="fields" :items="itens" :busy="tableBusy" :current-page="currentPage" hover
                no-border-collapse sort-by="" :sort-desc="true" stacked="sm" responsive show-empty>
                <template #empty>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                    <div class="text-center text-dark">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="loading-text">Carregando...</strong>
                    </div>
                </template>
                <template v-slot:cell(actions)="row">
                    <div class="actions-icons">
                        <b-link class="text-dark" @click="editarItemLicitacao(row.item)">
                            <font-awesome-icon icon="edit" />
                            <div style="font-size: 12px">Editar</div>
                        </b-link>
                        <btn-excluir v-if="!editItem" :key="row.item.IdItemLicitacao" :idItem="row.item"
                            :excluirItem="confirmarRemocao" />
                    </div>
                </template>
                <template #custom-foot>
                    <b-tr class="font-weight-bold">
                        <b-td colspan="5" class="text-right"></b-td>
                        <b-td class="text-right">
                            {{ licitacaoVlTotalEstimado ? formatMoeda(licitacaoVlTotalEstimado) : '' }}
                        </b-td>
                        <b-td></b-td>
                    </b-tr>
                </template>
            </b-table>
            <table-pagination v-if="totalRows > pageSize" :total-rows=totalRows :per-page=pageSize
                @pageChange="pageChange" />
        </b-row>
        <modal-importar-itens-licitacao v-if="exibirModalImportacao" @fecharModal="onFecharModalImportacao"
            :idLicitacao="lic.IdLicitacao" />
    </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue"
import BuscaTabela from "@/components/shared/BuscaTabela.vue"
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import { eventBus } from '@/main'
import ldiService from '@/services/licitacoes/ldiService'
import { store } from "@/store"
import { Decimal32dot4Props } from '@/types/form-default-props'
import { fieldEdicaoItemLicitacao, fieldsItemLicitacao } from '@/types/licitacoes/ldi/fields-item-licitacao'
import { ItemLicitacao } from '@/types/licitacoes/ldi/item-licitacao'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { Money } from 'v-money'
import { ValidationObserver } from "vee-validate"
import { mixins } from 'vue-class-component'
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalImportarItensLicitacao from '../ModalImportarItensLicitacao.vue'

const CompProps = Vue.extend({
    name: 'AbaEditarItens',
    components: { BtnExcluir, BuscaTabela, DefaultFormValidationProvider, ModalImportarItensLicitacao, TablePagination, ValidationObserver, Money },
    props: {
        lic: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class AbaEditarItens extends mixins(UtilsTS, CompProps) {
    @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
    licitaQtdProps = Decimal32dot4Props
    novoItem: ItemLicitacao = new ItemLicitacao()
    editItem = false //true para modo edição, false para modo inclusão

    //table-related
    fields: TableField[] = [...fieldsItemLicitacao, fieldEdicaoItemLicitacao]
    itens: ItemLicitacao[] = []
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false
    filtroTexto = ''
    licitacaoVlTotalEstimado: number | null = null

    //modal de importação
    exibirModalImportacao = false

    /** Validar e adicionar/alterar um participante a uma licitação existente */
    async salvar(): Promise<void> {
        try {
            store.blockScreen = true
            const isValid = await this.validationobserver.validate();
            if (!isValid) {
                console.error(this.validationobserver)
            } else {
                const retorno = await ldiService.adicionarItemLicitacao(this.novoItem)
                if (this.editItem) {
                    this.$toast.success(`O item ${retorno.DeItemMatServ} foi atualizado.`)
                    this.itens = this.itens.filter(p => p.IdItemLicitacao !== retorno.IdItemLicitacao)
                } else {
                    this.$toast.success(`O item ${retorno.DeItemMatServ} foi adicionado a esta licitação.`)
                }
                this.itens.unshift(retorno)
                eventBus.$emit('atualizar-status-licitacao')
                this.limparForm()
                this.loadData()
            }
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            store.blockScreen = false
        }
    }
    limparForm(): void {
        this.novoItem = new ItemLicitacao()
        this.novoItem.IdLicitacao = this.lic.IdLicitacao
        this.editItem = false
        this.validationobserver.reset();
    }
    async mounted(): Promise<void> {
        this.novoItem.IdLicitacao = this.lic.IdLicitacao
        await this.loadData()
    }
    async loadData(): Promise<void> {
        try {
            this.tableBusy = true
            const response = await ldiService.buscarItens(this.lic.IdLicitacao, this.currentPage, this.pageSize, this.filtroTexto)
            if (response) {
                this.itens = response.itens.map(l => {
                    const item = Object.assign(new ItemLicitacao(), l)
                    return item
                })
                this.totalRows = response.totalRows
                this.licitacaoVlTotalEstimado = response.licitacaoVlTotalEstimado
            } else {
                this.$toast.error('Erro ao consultar os itens desta licitação.');
            }
        } finally {
            this.tableBusy = false;
        }
    }
    async pageChange(value: number): Promise<void> {
        this.currentPage = value;
        await this.loadData();
    }
    async editarItemLicitacao(value: ItemLicitacao): Promise<void> {
        this.novoItem = Object.assign(new ItemLicitacao(), value)
        this.editItem = true
    }
    async confirmarRemocao(item: ItemLicitacao): Promise<void> {
        try {
            if (item.TemVencedor) {
                const respostaUsuario = await this.$bvModal.msgBoxConfirm(
                    'Há vencedor cadastrado para este item. Ao removê-lo, a situação da licitação poderá ser alterada.',
                    {
                        buttonSize: 'sm',
                        cancelTitle: 'Não remova este item',
                        cancelVariant: 'outline-secondary',
                        centered: true,
                        headerBgVariant: 'secondary',
                        headerTextVariant: 'light',
                        okTitle: 'Quero remover o item',
                        title: 'Confirmar exclusão de item',
                    })
                if (respostaUsuario) {
                    await this.removerItemLicitacao(item)
                }
            } else {
                await this.removerItemLicitacao(item)
            }
        } catch (e: any) {
            this.tratarError(e)
        }
    }
    async removerItemLicitacao(item: ItemLicitacao): Promise<void> {
        try {
            store.blockScreen = true
            const retorno = await ldiService.removerItemLicitacao(item.IdItemLicitacao)
            if (retorno) {
                this.itens = this.itens.filter(p => p.IdItemLicitacao !== item.IdItemLicitacao)
                this.$emit('input', this.itens);
                this.$toast.success(`O item ${item.DeItemMatServ} foi removido desta licitação.`)
                eventBus.$emit('atualizar-status-licitacao')
            }
            else this.$toast.error(`Falha ao remover o item ${item.DeItemMatServ}.`)
            await this.loadData()
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            store.blockScreen = false
        }
    }
    async onFecharModalImportacao(refresh = false): Promise<void> {
        this.exibirModalImportacao = false
        if (refresh) await this.loadData()
    }

    async filtrarItens(filtro: string): Promise<void> {
        this.filtroTexto = filtro
        this.currentPage = 1
        await this.loadData()
    }
}
</script>